module.exports = __webpack_public_path__ + "img/banner_left.4bd94dbc.png";